import { jsx, jsxs } from 'react/jsx-runtime';
import '../../../../../../contexts/MicrositeMenuContext/index.mjs';
import { MenuCategoryId } from '../../../../../../contexts/MicrositeMenuContext/mapping.mjs';
import { useMicrositeMenuTranslations } from '../../../../../../contexts/MicrositeMenuContext/translations.mjs';
import { imageSrc } from '../../../../../../utils/asset.mjs';
import { MODEL_COMPARE_V4_ANCHOR } from '../../../../../ModelCompareV4/ModelCompareV4.mjs';
import { Wrap, MenuWrap, MenuInnerWrap, Container, FlexColumn, SubNavItemsWrapper, SubNavItem, StyledImg, Title, Description, CompareExploreAnchor, Badge } from './SubNavigation.styles.mjs';
import { useMicrositeMenu } from '../../../../../../contexts/MicrositeMenuContext/context.mjs';
"use strict";
const CATEGORY_WIDTH_MAP = {
  [MenuCategoryId.CloudGateways]: 164,
  [MenuCategoryId.Switching]: 164,
  [MenuCategoryId.WiFi]: 164,
  [MenuCategoryId.PhysicalSecurity]: 136,
  [MenuCategoryId.Integrations]: 164
};
const LONG_LANGUAGES = ["el", "de", "ja", "it", "fr"];
const SubNavigation = ({
  menu,
  show,
  onMenuItemClick
}) => {
  const {
    language
  } = useMicrositeMenu();
  const {
    formatMessage
  } = useMicrositeMenuTranslations(language);
  return /* @__PURE__ */jsx(Wrap, {
    motif: "light",
    children: /* @__PURE__ */jsx(MenuWrap, {
      motif: "light",
      $slideInView: show,
      $height: 264 + (LONG_LANGUAGES.includes(language) ? 50 : 0),
      children: /* @__PURE__ */jsx(MenuInnerWrap, {
        $shouldShow: show,
        children: /* @__PURE__ */jsx(Container, {
          size: "desktop",
          noVerticalMargin: true,
          children: /* @__PURE__ */jsx(FlexColumn, {
            children: /* @__PURE__ */jsx(SubNavItemsWrapper, {
              $isVisible: show,
              $isDenseGrid: menu?.id === MenuCategoryId.PhysicalSecurity,
              children: (menu?.items ?? []).map(navItem => /* @__PURE__ */jsxs(SubNavItem, {
                $isActive: navItem.active,
                $maxWidth: CATEGORY_WIDTH_MAP?.[menu?.id],
                onClick: e => onMenuItemClick?.(e, navItem?.url),
                children: [!!navItem?.image?.src && /* @__PURE__ */jsx(StyledImg, {
                  src: imageSrc(navItem.image.src),
                  alt: navItem.label
                }), /* @__PURE__ */jsx(Title, {
                  children: formatMessage(navItem.label)
                }), !!navItem?.description && /* @__PURE__ */jsx(Description, {
                  dangerouslySetInnerHTML: {
                    __html: formatMessage(navItem.description)
                  }
                }), !!navItem?.isOverview && /* @__PURE__ */jsx(CompareExploreAnchor, {
                  onClick: event => {
                    event.stopPropagation();
                    onMenuItemClick?.(event, `${navItem?.url}#${MODEL_COMPARE_V4_ANCHOR}`);
                  },
                  children: formatMessage("commons.menu.label.compareAll")
                }), !!navItem?.isNew && /* @__PURE__ */jsx(Badge, {
                  children: formatMessage("commons.menu.label.new")
                })]
              }, navItem.id))
            })
          })
        })
      })
    })
  });
};
export { SubNavigation };
//# sourceMappingURL=SubNavigation.mjs.map
